
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[displayname]/trainings/[tid]/courses/[id]",
      function () {
        return require("private-next-pages/companies/[displayname]/trainings/[tid]/courses/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/[displayname]/trainings/[tid]/courses/[id]"])
      });
    }
  